var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('eta-salle-list',{attrs:{"salleList":_vm.getSalles,"page":_vm.optionsPaginate.page,"length":_vm.optionsPaginate.length,"search":_vm.search},on:{"click:salle":_vm.onClickSalle,"update:search":_vm.onUpdateSearch,"update:page":_vm.onUpdatePage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }